export const debounce =
  (callback: (...args: any[]) => void, time: number = 250, interval?: any) =>
  (...args) => {
    clearTimeout(interval);
    interval = setTimeout(() => callback(...args), time);
  };
